import { Container, Grid, Typography, makeStyles } from "@material-ui/core";

import { ITheme } from "../constants/theme";
import React from "react";
import { useTranslation } from 'react-i18next';

export const OrderDetailsCustomerInformationSection = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const data: any = props.data;
  return (
    <Container className={classes.customerInformationContainer}>
      <Grid container>
        <Grid container className={classes.infoTitle}>
          <Typography variant="h6" component="span">
            {t('orderDetails.customerInformation')}
          </Typography>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.name')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {data?.CustomerFirstName + " " + data?.CustomerLastName}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.email')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {data?.CustomerEmail}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.phone')}
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {data?.CustomerTelNo}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainerLastRow}>
          <Grid
            container
            item
            xs={3}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Typography
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('orderDetails.billingAddress')}
            </Typography>
          </Grid>
          <Grid
            item
            container
            direction="row"
            xs={9}
            className={classes.colOffset}
          >
            <Grid item xs={12}>
              <Typography variant="body1" component="span" color="textPrimary">
                {GetAddressLine(data)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
const GetAddressLine = (data: any) => {
  return (
    data?.BillingAddressLine1 +
    ", " +
    (data?.BillingAddressLine2 && `${data?.BillingAddressLine2}, `) +
    (data?.BillingAddressLine3 && `${data?.BillingAddressLine3}, `) +
    data.BillingAddressCity +
    " " +
    data.BillingAddressPostCode +
    ", " +
    data.BillingAddressCounty
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  customerInformationContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "18px 24px 0",
    marginTop: "24px",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
  },
  infoTitle: {
    marginBottom: 20,
  },
  infoTextContainer: {
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  infoTextContainerLastRow: {
    paddingTop: 15,
    paddingBottom: 15,
  },
  colOffset: {
    marginLeft: -17.5,
    marginRight: 17.5,
  },
}));
